function isValidDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;

  const date = new Date(`${value}T00:00:00`);
  return !Number.isNaN(date.getTime())
    && date.getFullYear() === Number(value.slice(0, 4))
    && date.getMonth() + 1 === Number(value.slice(5, 7))
    && date.getDate() === Number(value.slice(8, 10));
}

export function calculateCurrentAge(birthDate, today = new Date()) {
  if (!isValidDate(birthDate)) return null;

  const [birthYear, birthMonth, birthDay] = birthDate.split('-').map(Number);
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const currentDay = today.getDate();

  if (
    birthYear > currentYear
    || (birthYear === currentYear && birthMonth > currentMonth)
    || (birthYear === currentYear && birthMonth === currentMonth && birthDay > currentDay)
  ) {
    return null;
  }

  const age = currentYear - birthYear;
  const birthdayHasNotOccurred = currentMonth < birthMonth
    || (currentMonth === birthMonth && currentDay < birthDay);

  return birthdayHasNotOccurred ? age - 1 : age;
}
